import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class WhatsappMessageLogsService {


  url = environment.serverAPI4 + "/api/whatsappMessageLogs";

  url2 = environment.serverAPI8 + "/api/whatsappmessageLogsReport";

  constructor(private http: HttpClient) { }

  getAllWhatsappMessageLogs(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllWhatsappMessageLogsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getWhatsappMessageLogsById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditWhatsappMessageLogs(brand: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, brand);
  }

  whatsappMessageLogsSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }


  searchMessageLogReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }

}
